import { escapeAttrValue } from "./utils";

const FilterAll = () => {
  const init = () => {
    const forms = document.querySelectorAll("form");
    forms.forEach((form) => {
      form.addEventListener("change", (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type !== "checkbox" || !target.name) return;

        const escapedName = escapeAttrValue(target.name);

        if (target.value === "0") {
          if (target.checked) {
            const others = form.querySelectorAll(
              `input[type='checkbox'][name='${escapedName}']:not([value='0'])`
            );
            others.forEach((checkbox) => {
              checkbox.checked = false;
            });
          }
          return;
        }

        if (target.checked) {
          const zeroCheckbox = form.querySelector(
            `input[type='checkbox'][name='${escapedName}'][value='0']`
          );
          if (zeroCheckbox) {
            zeroCheckbox.checked = false;
          }
        }
      });
    });
  };

  return { init };
};
export default FilterAll;
